import * as C from "react";
import R from "react";
import { jsx as I } from "react/jsx-runtime";
import { u as P, S as A } from "./index-DoEshza7.js";
var h = C.createContext(void 0);
function $(e) {
  const r = C.useContext(h);
  return e || r || "ltr";
}
function O(e, r = []) {
  let u = [];
  function M(s, o) {
    const n = C.createContext(o), i = u.length;
    u = [...u, o];
    function x(m) {
      const { scope: a, children: c, ...t } = m, d = (a == null ? void 0 : a[e][i]) || n, l = C.useMemo(() => t, Object.values(t));
      return /* @__PURE__ */ I(d.Provider, { value: l, children: c });
    }
    function _(m, a) {
      const c = (a == null ? void 0 : a[e][i]) || n, t = C.useContext(c);
      if (t) return t;
      if (o !== void 0) return o;
      throw new Error(`\`${m}\` must be used within \`${s}\``);
    }
    return x.displayName = s + "Provider", [x, _];
  }
  const f = () => {
    const s = u.map((o) => C.createContext(o));
    return function(n) {
      const i = (n == null ? void 0 : n[e]) || s;
      return C.useMemo(
        () => ({ [`__scope${e}`]: { ...n, [e]: i } }),
        [n, i]
      );
    };
  };
  return f.scopeName = e, [M, T(f, ...r)];
}
function T(...e) {
  const r = e[0];
  if (e.length === 1) return r;
  const u = () => {
    const M = e.map((f) => ({
      useScope: f(),
      scopeName: f.scopeName
    }));
    return function(s) {
      const o = M.reduce((n, { useScope: i, scopeName: x }) => {
        const m = i(s)[`__scope${x}`];
        return { ...n, ...m };
      }, {});
      return C.useMemo(() => ({ [`__scope${r.scopeName}`]: o }), [o]);
    };
  };
  return u.scopeName = r.scopeName, u;
}
function b(e) {
  const r = e + "CollectionProvider", [u, M] = O(r), [f, s] = u(
    r,
    { collectionRef: { current: null }, itemMap: /* @__PURE__ */ new Map() }
  ), o = (c) => {
    const { scope: t, children: d } = c, l = R.useRef(null), p = R.useRef(/* @__PURE__ */ new Map()).current;
    return /* @__PURE__ */ I(f, { scope: t, itemMap: p, collectionRef: l, children: d });
  };
  o.displayName = r;
  const n = e + "CollectionSlot", i = R.forwardRef(
    (c, t) => {
      const { scope: d, children: l } = c, p = s(n, d), S = P(t, p.collectionRef);
      return /* @__PURE__ */ I(A, { ref: S, children: l });
    }
  );
  i.displayName = n;
  const x = e + "CollectionItemSlot", _ = "data-radix-collection-item", m = R.forwardRef(
    (c, t) => {
      const { scope: d, children: l, ...p } = c, S = R.useRef(null), N = P(t, S), v = s(x, d);
      return R.useEffect(() => (v.itemMap.set(S, { ref: S, ...p }), () => void v.itemMap.delete(S))), /* @__PURE__ */ I(A, { [_]: "", ref: N, children: l });
    }
  );
  m.displayName = x;
  function a(c) {
    const t = s(e + "CollectionConsumer", c);
    return R.useCallback(() => {
      const l = t.collectionRef.current;
      if (!l) return [];
      const p = Array.from(l.querySelectorAll(`[${_}]`));
      return Array.from(t.itemMap.values()).sort(
        (v, E) => p.indexOf(v.ref.current) - p.indexOf(E.ref.current)
      );
    }, [t.collectionRef, t.itemMap]);
  }
  return [
    { Provider: o, Slot: i, ItemSlot: m },
    a,
    M
  ];
}
export {
  b as c,
  $ as u
};
